import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { GlobalConstants } from 'src/app/constant/constant';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private authService: AuthService
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    await this.authService.ready;
    if (!this.checkIsAuthenticated()) {
      await this.redirectToLogin();
      return false;
    }

    if (!this.checkIsPrivacyAccepted()) {
      await this.redirectToPrivacyPolicy();
      return false;
    }

    if (!this.checkIsTermsAccepted()) {
      await this.redirectToTermsOfService();
      return false;
    }

    return true;
  }

  private checkIsAuthenticated(): boolean {
    return this.authService.isAuthenticated();
  }

  private checkIsPrivacyAccepted(): boolean {
    return JSON.parse(localStorage.getItem(GlobalConstants.IS_PRIVACYACCEPTED)) ?? false;
  }

  private checkIsTermsAccepted(): boolean {
    return JSON.parse(localStorage.getItem(GlobalConstants.IS_TERMSACCEPTED)) ?? false;
  }

  private async redirectToLogin(): Promise<void> {
    await this.router.navigate(['auth/login'], { replaceUrl: true });
  }

  private async redirectToPrivacyPolicy(): Promise<void> {
    await this.router.navigate(['privacyPolicy'], { replaceUrl: true });
  }

  private async redirectToTermsOfService(): Promise<void> {
    await this.router.navigate(['termsOfService'], { replaceUrl: true });
  }

}
